import { Math } from "core-js";

const namespaced = true;
const defaultState = () => ({

  originData: [], //原始資料
  sources: [],
  dateRange: [], //日期範圍
  highchartColor: ["#ffc000", "#66bb6a", "#ed7d31", "#a5a5a5", "#5b9bd5"], // highchart color
  customerName: ["新訪客", "活躍客群", "潛在客群", "回流訪客"], // group type 翻譯
  customerBaseReport: {}, // 總體客群趨勢圖




  date: "",
  dateIndex: -1,
  distinctCount: 0, // 單日不重複瀏覽
  // groupTagsCount: 0,
  customerGroupReport: {}, // 單日客群分析
  interestDistributedReport: {}, // 單日興趣分布

  countType: ""
});
const state = defaultState();

const mutations = {

  resetState: (state) => Object.assign(state, defaultState()),
  // 原始資料
  setOriginData: (state, data) => {
    state.originData = data
  },
  // sources
  setSources: (state, sources) => (state.sources = [...sources]),
  // 日期範圍，不管有幾個 source，取第一筆資料的日期即可
  setDateRange: (state) => {
    state.dateRange = state.originData.data.map((el) => el.date)
  },

  setDate: (state, dateIndex = -1) => {

    dateIndex > -1
      ? state.dateIndex = dateIndex
      : state.dateIndex = state.dateRange.length - 1;

    state.date = state.dateRange[state.dateIndex].substring(5)




  },
  //當日進站客群/180內進站人群
  setCountType: (state, type) => {
    state.countType = type
  },
  // setDistinctCount: (state, index = -1) => {

  //   state.distinctCount =
  //     // index > -1
  //     // ? state.originData.data[state.dateRange.length - 1].group[index].all_distinct_count
  //     // : state.originData.data[state.dateRange.length - 1].group.reduce(
  //     //   (preCount, curObj) => (preCount += parseInt(curObj.all_distinct_count)),
  //     //   0
  //     // );
  //     index > -1
  //       ? state.originData.data[state.dateRange.length - 1].group[index].all_distinct_count
  //       : state.originData.data[state.dateRange.length - 1].group.reduce(
  //         (preCount, curObj) => (preCount += parseInt(curObj.all_distinct_count)),
  //         0
  //       );


  //   state.y =
  //     // index > -1
  //     //   ? state.originData.data[state.dateRange.length - 1].group[index].distinct_count
  //     //   : state.originData.data[state.dateRange.length - 1].group.reduce(
  //     //     (preCount, curObj) => (preCount += parseInt(curObj.distinct_count)),
  //     //     0
  //     //   );

  //     index > -1
  //       ? state.originData.data[state.dateRange.length - 1].group[index].distinct_count
  //       : state.originData.data[state.dateRange.length - 1].group.reduce(
  //         (preCount, curObj) => (preCount += parseInt(curObj.distinct_count)),
  //         0
  //       );

  // },


  // 單日客群分析，使用滾動資料
  setCustomerReport: (state, dateIndex = -1) => {



    dateIndex = dateIndex > -1
      ? dateIndex
      : state.dateRange.length - 1;

    var type;
    if (state.countType == "acc_") {
      type = " 180日"
    } else {
      type = " 當日"
    }

    const customerGroupReport = {
      chartTitle: `${state.date}${type}客群分析圖`,
      seriesData: [],
    };

    const totalDistinctCount = state.originData.data[dateIndex].group.reduce(

      (total, currentGroup) =>
        // total + parseInt(currentGroup.distinct_count),
        total + parseInt(currentGroup[state.countType + "distinct_count"]),
      0
    );

    if (totalDistinctCount > 0) {
      state.originData.data[dateIndex].group.forEach((el, index) => {

        customerGroupReport.seriesData.push({
          name: state.customerName[index],
          color: state.highchartColor[index],
          // value: Math.round((el.distinct_count / totalDistinctCount) * 100),
          value: Math.round((el[state.countType + "distinct_count"] / totalDistinctCount) * 100),
        });
      });
    }


    state.customerGroupReport = customerGroupReport;
  },
  // 單日興趣分布，使用滾動資料
  setInterestReport: (state, groupIndex = 4) => {

    state.interestDistributedReport = {}
    const distributedData = [];
    // 攤平資料，groupIndex 4 為客群總和
    const concatOriginData =
      groupIndex === 4
        ? state.originData.data[state.dateIndex].group.reduce(
          (groupObj, curtagObj) =>
            groupObj.concat(
              // curtagObj.tags.reduce(
              curtagObj[state.countType + "tags"].reduce(
                (tagObj, curtagObj) => tagObj.concat(curtagObj),
                []
              )
            ),
          []
        )
        // : state.originData.group[groupIndex].tags.reduce(
        : state.originData.data[state.dateIndex].group[groupIndex][state.countType + "tags"].reduce(
          (tagObj, curtagObj) => tagObj.concat(curtagObj),
          []
        );
    // 計算興趣分布 (重複標籤加總)
    // concatOriginData.forEach((item) => {
    //   const { type, subject, count } = item;
    //   const currentName = `${type}:${subject}`;
    //   const existData = distributedData.find(
    //     (e) => `${e.name}` === currentName
    //   );
    //   existData
    //     ? (existData.count += parseInt(count))
    //     : distributedData.push({
    //       name: currentName,
    //       count: parseInt(count),
    //     });
    //   // console.log("existData", existData)
    // });

    // //標籤數量總數，網站人群貼標需使用
    state.groupTagsCount = distributedData.reduce(
      (total, current) => total + parseInt(current.count),
      0
    );


    // 計算興趣結構 (重複 type 取 count 最大值)
    concatOriginData.sort((a, b) => b.count - a.count);
    // const tempArr = [...concatOriginData];
    const structureData = [];
    var filterData = [];
    for (let index = 0; index < concatOriginData.length; index++) {
      //切割類別排名圖的頭到尾資料，第一個為所選標籤
      if(state.originData.tag.substring(1,state.originData.tag.length-1) === concatOriginData[index].subject){
        filterData = concatOriginData.slice(index, concatOriginData.length);
        break;
      }else{
        filterData = concatOriginData.slice(0, concatOriginData.length);
      }
    }

    while (filterData.length > 0 && structureData.length < 15) {
      const item = filterData.shift();
      const typeCompare = (el) => el.type === item.type;
      const exists = structureData.some(typeCompare);
      if (!exists) {
        structureData.push(item);
      }
    }
    const tagClass = [];
    structureData.forEach((item) => {
      const { type, subject, count } = item;
      const currentName = `${type}:${subject}`;
      const existData = tagClass.find(
        (e) => `${e.name}` === currentName
      );
      existData
        ? (existData.count += parseInt(count))
        : tagClass.push({
          name: currentName,
          count: parseInt(count),
        });
      // console.log("existData", existData)
    });


    var type;
    if (state.countType == "acc_") {
      type = " 180日"
    } else {
      type = " 當日"
    }

    state.interestDistributedReport = {
      chartTitle: `${state.date}${type}興趣類別排名`,
      subtitle:
        groupIndex === 4 ? `總體客群` : `${state.customerName[groupIndex]}`,
      data: tagClass,//distributedData.sort((a, b) => b.count - a.count).slice(0, 15), // 興趣分布排序
      color: state.highchartColor[groupIndex],
    };
  },



  // 總體客群趨勢圖，使用滾動資料
  setCustomerBaseReport: (state,) => {
    const sourceData = state.originData;
    const report = {
      source: state.sources,
      series: [],
    };

    for (let index of Array(4).keys()) {
      report.series.push({
        name: state.customerName[index],
        color: state.highchartColor[index],
        data: sourceData.data.map((el) =>
          parseInt(el.group[index][state.countType + "distinct_count"])
          // parseInt(el.group[index].distinct_count)

        ),
        extra: 1,
      });
    }
    state.customerBaseReport = report;
  },

};



const actions = {


  setOriginData: ({ commit }, data) => { //set origindata
    commit("setOriginData", data)
    commit("setDateRange")
    commit("setDate")
    commit("setCustomerBaseReport", 0)

    // commit("setDistinctCount");
    commit("setCustomerReport");

    //預設:最多人數的客群人數
    const defaultGroupValue = Math.max(...state.customerGroupReport.seriesData.map(p => p.value))

    let defaultGroupName;
    //預設客群名稱
    state.customerGroupReport.seriesData.some(group => {
      if (group.value === defaultGroupValue) {
        defaultGroupName = group.name
        return true
      }
    })

    //設定預設客群
    for (var index = 0; index < state.customerName.length; index++) {
      if (defaultGroupName == state.customerName[index]) {

        commit("setInterestReport", index);
        break;
      } else if (defaultGroupName == undefined) {
        commit("setInterestReport");
      }
    }

  },
  setChartWithType: ({ commit }, countType) => {
    commit("setCountType", countType)
    commit("setCustomerBaseReport", 0)
    // commit("setDistinctCount");
    commit("setCustomerReport", state.dateIndex);
    //預設:最多人數的客群人數
    const defaultGroupValue = Math.max(...state.customerGroupReport.seriesData.map(p => p.value))

    let defaultGroupName;
    //預設客群名稱
    state.customerGroupReport.seriesData.some(group => {
      if (group.value === defaultGroupValue) {
        defaultGroupName = group.name
        return true
      }
    })
    //設定預設客群
    for (var index = 0; index < state.customerName.length; index++) {
      if (defaultGroupName == state.customerName[index]) {
        commit("setInterestReport", index);
        break;
      }
    }
  },

  updateCustomerReport: ({ commit }, { dateIndex, groupName }) => {

    commit("setDate", dateIndex)
    commit("setCustomerReport", dateIndex);


    for (var index = 0; index < state.customerName.length; index++) {
      if (groupName == state.customerName[index]) {
        commit("setInterestReport", index);

        break;
      }
    }
  }
  ,

  updateInterestReport: ({ commit }, groupIndex) => {
    //總體客群
    commit("setInterestReport", groupIndex);

  },

};
const getters = {
  getDataSources: (state) => state.sources, // sources
  getDateRange: (state) => state.dateRange, // 日期範圍
  getCustomerBaseReport: (state) => (state.customerBaseReport), // 總體客群趨勢圖,.
  getDate: (state) => state.originData.date, //date
  getCustomerReport: (state) => state.customerGroupReport, //單日客群樹狀圖
  getDistributed: (state) => state.interestDistributedReport, //單日興趣分布
  getCrowdTag: (state) => state.crowdTagReport, // 人群貼標
  getCrowdTagMenu: (state) => state.crowdTagMenu,//提示框
};

export default { namespaced, state, actions, mutations, getters }